
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foerderung/wissenswertes/[slug]",
      function () {
        return require("private-next-pages/foerderung/wissenswertes/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foerderung/wissenswertes/[slug]"])
      });
    }
  